module.exports = __webpack_public_path__ + "img/Insurance-cost.ab01d3d2.svg";